import { render } from "./Navigation.vue?vue&type=template&id=157070a2"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=157070a2&lang=scss"
script.render = render

export default script